import { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query'

import { OffersAndMetadata } from '@wwt/entities/search-response'

export const filterCurrentOffer = (
	offersResponse: UseInfiniteQueryResult<
		InfiniteData<OffersAndMetadata, unknown>,
		Error
	>,
	hotelId: string | undefined,
	roomId: string | undefined
): UseInfiniteQueryResult<InfiniteData<OffersAndMetadata, unknown>, Error> => {
	if (!hotelId || !roomId) {
		return offersResponse
	}

	const newPages =
		offersResponse.data?.pages.map(page => {
			const newOffers = page.offers.filter(offer => {
				return (
					offer.IDs.integrationHotelId === hotelId &&
					offer.IDs.integrationRoomId !== roomId
				)
			})

			return {
				...page,
				offers: newOffers
			}
		}) ?? ([] as OffersAndMetadata[])

	return {
		data: {
			...offersResponse.data,
			pages: newPages
		}
	} as UseInfiniteQueryResult<InfiniteData<OffersAndMetadata, unknown>, Error>
}
